import { useMemo } from "react";

import { useAppUser } from "~/providers/UserProvider";
import { FeatureKey } from "~/types/subscription";

export const useWatchlistPermissions = () => {
  const { userSubscriptionPermissions } = useAppUser();

  return useMemo(() => {
    const hasLimitThree = userSubscriptionPermissions.includes(
      FeatureKey.WATCHLIST_LIMIT_THREE
    );
    const hasNoLimits = userSubscriptionPermissions.includes(
      FeatureKey.WATCHLIST_NO_LIMITS
    );

    return {
      hasLimitThree,
      hasNoLimits,
      hasAnyWatchlistFeature: hasLimitThree || hasNoLimits,
    };
  }, [userSubscriptionPermissions]);
};
